// Topic Cluster Hierarchy for Internal Linking Automation
// Defines pillar → hub → spoke → blog relationships for SEO authority building

export const TOPIC_CLUSTERS = {
  residential: {
    pillar: "/florida-roofing-services",
    hub: "/residential-roofing",
    spokes: [
      { path: "/services/metal-roofing", name: "Metal Roofing", anchors: ["metal roofing", "metal roof installation", "standing seam metal roofs"] },
      { path: "/services/tile-roofing", name: "Tile Roofing", anchors: ["tile roofing", "clay tile roofs", "concrete tile installation"] },
      { path: "/services/shingle-roofing", name: "Shingle Roofing", anchors: ["shingle roofing", "asphalt shingles", "architectural shingles"] },
      { path: "/roof-repair", name: "Roof Repair", anchors: ["roof repair", "fix roof leaks", "repair storm damage"] },
      { path: "/roof-replacement", name: "Roof Replacement", anchors: ["roof replacement", "new roof installation", "replace old roof"] },
      { path: "/services/roof-inspection", name: "Roof Inspection", anchors: ["roof inspection", "annual roof checkup", "professional inspection"] },
      { path: "/roofing-materials-comparison", name: "Materials Comparison", anchors: ["roofing materials comparison", "metal vs tile vs shingle", "best roof material Florida"] },
      { path: "/florida-building-codes", name: "Building Codes", anchors: ["Florida building codes", "roofing code requirements", "HVHZ requirements"] },
    ],
    blogs: [
      "best-roofing-materials-florida",
      "roof-maintenance-tips",
      "signs-you-need-new-roof",
      "florida-roof-inspection-checklist",
      "hurricane-season-roof-prep",
    ],
  },
  commercial: {
    pillar: "/florida-roofing-services",
    hub: "/commercial-roofing",
    spokes: [
      { path: "/services/flat-roofing", name: "Flat Roofing", anchors: ["flat roofing", "commercial flat roofs", "low-slope roofing"] },
      { path: "/services/metal-roofing", name: "Commercial Metal", anchors: ["commercial metal roofing", "metal roof systems"] },
    ],
    blogs: [
      "commercial-roof-problems-florida",
      "tpo-vs-pvc-vs-epdm-comparison",
      "flat-roof-maintenance-guide",
      "commercial-roof-inspection-checklist",
      "preventive-maintenance-programs",
    ],
  },
  insurance: {
    pillar: "/florida-roofing-services",
    hub: "/roof-insurance-claims",
    spokes: [
      { path: "/emergency", name: "Emergency Repair", anchors: ["emergency roof repair", "24/7 roofing service", "storm damage repair"] },
      { path: "/leak-detection", name: "Leak Detection", anchors: ["leak detection", "find roof leaks", "water damage inspection"] },
    ],
    blogs: [
      "document-roof-damage-insurance",
      "insurance-adjuster-meeting-tips",
      "storm-damage-signs-after-hurricane",
      "roof-repair-vs-replacement-florida",
      "insurance-claim-timeline",
    ],
  },
  rooferFinder: {
    pillar: "/roofing-near-me",
    hub: "/roofers-near-me",
    spokes: [
      { path: "/roof-repair-near-me", name: "Roof Repair Near Me", anchors: ["roof repair near me", "find roof repair", "local roof repair"] },
      { path: "/roof-replacement-near-me", name: "Roof Replacement Near Me", anchors: ["roof replacement near me", "new roof near me", "find roof replacement"] },
      { path: "/roof-inspection-near-me", name: "Roof Inspection Near Me", anchors: ["roof inspection near me", "free roof inspection", "local roof inspection"] },
      { path: "/metal-roofing-near-me", name: "Metal Roofing Near Me", anchors: ["metal roofing near me", "metal roof contractors", "standing seam near me"] },
      { path: "/tile-roofing-near-me", name: "Tile Roofing Near Me", anchors: ["tile roofing near me", "tile roof installers", "clay tile near me"] },
      { path: "/shingle-roofing-near-me", name: "Shingle Roofing Near Me", anchors: ["shingle roofing near me", "shingle contractors", "GAF installers"] },
      { path: "/flat-roofing-near-me", name: "Flat Roofing Near Me", anchors: ["flat roofing near me", "TPO roofing near me", "commercial flat roof"] },
      { path: "/emergency-roofing-near-me", name: "Emergency Roofing Near Me", anchors: ["emergency roofing near me", "urgent roof repair", "24/7 roofer"] },
    ],
    blogs: [
      "how-to-find-good-roofer",
      "questions-to-ask-roofing-company",
      "red-flags-hiring-roofer",
      "why-choose-local-roofer",
    ],
  },
  quoteCapture: {
    pillar: "/quick-estimate",
    hub: "/get-quote",
    spokes: [
      { path: "/roofing-quotes-naples", name: "Quotes Naples", anchors: ["roofing quotes Naples", "free estimate Naples"] },
      { path: "/roofing-quotes-fort-myers", name: "Quotes Fort Myers", anchors: ["roofing quotes Fort Myers", "free estimate Fort Myers"] },
      { path: "/roofing-quotes-cape-coral", name: "Quotes Cape Coral", anchors: ["roofing quotes Cape Coral", "free estimate Cape Coral"] },
      { path: "/roofing-quotes-sarasota", name: "Quotes Sarasota", anchors: ["roofing quotes Sarasota", "free estimate Sarasota"] },
      { path: "/roof-estimate-naples", name: "Estimate Naples", anchors: ["roof estimate Naples", "roof cost Naples"] },
      { path: "/roof-estimate-fort-myers", name: "Estimate Fort Myers", anchors: ["roof estimate Fort Myers", "roof cost Fort Myers"] },
    ],
    blogs: [
      "roofing-quotes-what-to-look-for",
      "how-much-does-roof-cost-florida",
      "financing-roof-replacement-options",
    ],
  },
  emergencyAuthority: {
    pillar: "/emergency",
    hub: "/emergency-roofing-near-me",
    spokes: [
      { path: "/emergency-roofing-naples", name: "Emergency Naples", anchors: ["emergency roofing Naples", "urgent roof repair Naples"] },
      { path: "/emergency-roofing-fort-myers", name: "Emergency Fort Myers", anchors: ["emergency roofing Fort Myers", "24/7 roofer Fort Myers"] },
      { path: "/emergency-roofing-cape-coral", name: "Emergency Cape Coral", anchors: ["emergency roofing Cape Coral", "storm damage Cape Coral"] },
      { path: "/emergency-roofing-sarasota", name: "Emergency Sarasota", anchors: ["emergency roofing Sarasota", "roof emergency Sarasota"] },
    ],
    blogs: [
      "emergency-roof-repair-what-to-do",
      "storm-damage-roof-checklist",
      "roof-tarping-guide",
    ],
  },
  materialAuthority: {
    pillar: "/roofing-materials-comparison",
    hub: "/compare-materials",
    spokes: [
      { path: "/metal-roofing-near-me", name: "Metal Roofing Near Me", anchors: ["metal roofing near me", "find metal roofing"] },
      { path: "/tile-roofing-near-me", name: "Tile Roofing Near Me", anchors: ["tile roofing near me", "find tile roofing"] },
      { path: "/shingle-roofing-near-me", name: "Shingle Roofing Near Me", anchors: ["shingle roofing near me", "find shingle roofing"] },
      { path: "/flat-roofing-near-me", name: "Flat Roofing Near Me", anchors: ["flat roofing near me", "find flat roofing"] },
      { path: "/services/metal-roofing", name: "Metal Roofing", anchors: ["metal roof installation", "standing seam metal"] },
      { path: "/services/tile-roofing", name: "Tile Roofing", anchors: ["tile roof installation", "clay tile roofing"] },
    ],
    blogs: [
      "metal-vs-shingle-roof-florida",
      "tile-roofing-pros-cons",
      "best-roofing-material-florida-climate",
    ],
  },
  georgiaExpansion: {
    pillar: "/roofing/georgia",
    hub: "/roofing/georgia",
    spokes: [
      { path: "/roofers-in-macon", name: "Roofers Macon", anchors: ["roofers in Macon", "Macon roofing company"] },
      { path: "/roofers-in-savannah", name: "Roofers Savannah", anchors: ["roofers in Savannah", "Savannah roofing"] },
      { path: "/roofers-in-augusta", name: "Roofers Augusta", anchors: ["roofers in Augusta", "Augusta roofing company"] },
      { path: "/roofers-in-atlanta", name: "Roofers Atlanta", anchors: ["roofers in Atlanta", "Atlanta roofing"] },
      { path: "/roofers-in-columbus", name: "Roofers Columbus", anchors: ["roofers in Columbus GA", "Columbus roofing"] },
    ],
    blogs: [
      "georgia-roofing-costs",
      "hail-damage-georgia-roof",
      "georgia-building-codes-guide",
    ],
  },
  tennesseeExpansion: {
    pillar: "/roofing/tennessee",
    hub: "/roofing/tennessee",
    spokes: [
      { path: "/roofing/tn/nashville", name: "Nashville Roofing", anchors: ["Nashville roofers", "Nashville roofing company"] },
      { path: "/roofing/tn/memphis", name: "Memphis Roofing", anchors: ["Memphis roofers", "Memphis roofing"] },
      { path: "/roofing/tn/knoxville", name: "Knoxville Roofing", anchors: ["Knoxville roofers", "Knoxville roofing"] },
      { path: "/roofing/tn/chattanooga", name: "Chattanooga Roofing", anchors: ["Chattanooga roofers", "Chattanooga roofing"] },
    ],
    blogs: ["tornado-damage-roof-repair-guide", "tennessee-roofing-costs"],
  },
  alabamaExpansion: {
    pillar: "/roofing/alabama",
    hub: "/roofing/alabama",
    spokes: [
      { path: "/roofing/al/birmingham", name: "Birmingham Roofing", anchors: ["Birmingham roofers", "Birmingham roofing company"] },
      { path: "/roofing/al/huntsville", name: "Huntsville Roofing", anchors: ["Huntsville roofers", "Huntsville roofing"] },
      { path: "/roofing/al/mobile", name: "Mobile Roofing", anchors: ["Mobile roofers", "Mobile AL roofing"] },
    ],
    blogs: ["dixie-alley-tornado-roofing", "alabama-hail-damage-guide"],
  },
  southCarolinaExpansion: {
    pillar: "/roofing/south-carolina",
    hub: "/roofing/south-carolina",
    spokes: [
      { path: "/roofing/sc/charleston", name: "Charleston Roofing", anchors: ["Charleston roofers", "Charleston roofing company"] },
      { path: "/roofing/sc/greenville-sc", name: "Greenville Roofing", anchors: ["Greenville SC roofers", "Greenville roofing"] },
      { path: "/roofing/sc/myrtle-beach", name: "Myrtle Beach Roofing", anchors: ["Myrtle Beach roofers", "Myrtle Beach roofing"] },
    ],
    blogs: ["coastal-roofing-salt-air", "south-carolina-hurricane-prep"],
  },
  northCarolinaExpansion: {
    pillar: "/roofing/north-carolina",
    hub: "/roofing/north-carolina",
    spokes: [
      { path: "/roofing/nc/charlotte", name: "Charlotte Roofing", anchors: ["Charlotte roofers", "Charlotte roofing company"] },
      { path: "/roofing/nc/raleigh", name: "Raleigh Roofing", anchors: ["Raleigh roofers", "Raleigh roofing"] },
      { path: "/roofing/nc/asheville", name: "Asheville Roofing", anchors: ["Asheville roofers", "mountain roofing Asheville"] },
    ],
    blogs: ["mountain-roofing-ice-dams", "nc-hail-belt-protection"],
  },
} as const;

// Core pages that should receive the most internal links
export const CORE_PAGES = [
  { path: "/florida-roofing-services", name: "Florida Roofing Services", priority: 1 },
  { path: "/roofing/georgia", name: "Georgia Roofing Services", priority: 1 },
  { path: "/roofing/tennessee", name: "Tennessee Roofing Services", priority: 1 },
  { path: "/roofing/alabama", name: "Alabama Roofing Services", priority: 1 },
  { path: "/roofing/south-carolina", name: "South Carolina Roofing Services", priority: 1 },
  { path: "/roofing/north-carolina", name: "North Carolina Roofing Services", priority: 1 },
  { path: "/residential-roofing", name: "Residential Roofing", priority: 2 },
  { path: "/commercial-roofing", name: "Commercial Roofing", priority: 2 },
  { path: "/roof-insurance-claims", name: "Roof Insurance Claims", priority: 2 },
  { path: "/roof-repair", name: "Roof Repair", priority: 3 },
  { path: "/roof-replacement", name: "Roof Replacement", priority: 3 },
  { path: "/quick-estimate", name: "Free Estimate", priority: 3 },
] as const;

// Anchor text pools for natural variation (avoid duplicate exact-match anchors)
export const ANCHOR_POOLS = {
  pillar: [
    "Florida roofing services",
    "roofing services in Florida",
    "South Florida roofing experts",
    "Florida roof specialists",
    "complete roofing guide",
  ],
  residential: [
    "residential roofing",
    "home roofing services",
    "residential roof solutions",
    "homeowner roofing guide",
  ],
  commercial: [
    "commercial roofing",
    "business roofing services",
    "commercial roof solutions",
    "property management roofing",
  ],
  repair: [
    "roof repair services",
    "fix your roof",
    "professional roof repairs",
    "repair roof damage",
  ],
  replacement: [
    "roof replacement",
    "new roof installation",
    "replace your roof",
    "complete roof replacement",
  ],
  emergency: [
    "emergency roof repair",
    "24/7 roofing service",
    "urgent roof repairs",
    "storm damage response",
  ],
  insurance: [
    "roof insurance claims",
    "insurance claim assistance",
    "storm damage claims",
    "insurance claim help",
  ],
  estimate: [
    "get a free estimate",
    "request your free quote",
    "free roofing estimate",
    "no-obligation quote",
  ],
  roofer: [
    "local roofers",
    "find a roofer",
    "trusted roofers",
    "licensed roofer near me",
  ],
  roofingCompany: [
    "roofing company near me",
    "local roofing companies",
    "top roofing company",
    "best roofing company",
  ],
  nearMe: [
    "roofing near me",
    "roofers near me",
    "roof repair near me",
    "roof replacement near me",
  ],
} as const;

// Extended city pool for geographic internal linking
export const CITY_LINK_POOL = [
  { name: "Naples", slug: "naples", county: "Collier" },
  { name: "Fort Myers", slug: "fort-myers", county: "Lee" },
  { name: "Sarasota", slug: "sarasota", county: "Sarasota" },
  { name: "Tampa", slug: "tampa", county: "Hillsborough" },
  { name: "Cape Coral", slug: "cape-coral", county: "Lee" },
  { name: "North Port", slug: "north-port", county: "Sarasota" },
  { name: "Venice", slug: "venice", county: "Sarasota" },
  { name: "Bradenton", slug: "bradenton", county: "Manatee" },
  { name: "St. Petersburg", slug: "st-petersburg", county: "Pinellas" },
  { name: "Marco Island", slug: "marco-island", county: "Collier" },
  { name: "Bonita Springs", slug: "bonita-springs", county: "Lee" },
  { name: "Port Charlotte", slug: "port-charlotte", county: "Charlotte" },
  { name: "Punta Gorda", slug: "punta-gorda", county: "Charlotte" },
  { name: "Fort Lauderdale", slug: "fort-lauderdale", county: "Broward" },
  { name: "Miami", slug: "miami", county: "Miami-Dade" },
] as const;

// Helper to get random anchor from pool
export const getRandomAnchor = (pool: readonly string[]): string => {
  return pool[Math.floor(Math.random() * pool.length)];
};

// Helper to get deterministic anchor based on slug (for consistency)
export const getDeterministicAnchor = (pool: readonly string[], seed: string): string => {
  const index = seed.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) % pool.length;
  return pool[index];
};

// Helper to get rotating city based on seed
export const getRotatingCity = (seed: string) => {
  const index = seed.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) % CITY_LINK_POOL.length;
  return CITY_LINK_POOL[index];
};

// Get related pages based on current path
export const getRelatedPages = (currentPath: string, maxLinks: number = 3) => {
  const related: { path: string; name: string; anchor: string }[] = [];
  
  // Always include pillar if not on pillar
  if (currentPath !== "/florida-roofing-services") {
    related.push({
      path: "/florida-roofing-services",
      name: "Florida Roofing Services",
      anchor: getDeterministicAnchor(ANCHOR_POOLS.pillar, currentPath),
    });
  }
  
  // Find cluster this page belongs to
  for (const [clusterName, cluster] of Object.entries(TOPIC_CLUSTERS)) {
    const isHub = currentPath === cluster.hub;
    const spoke = cluster.spokes.find(s => s.path === currentPath);
    
    if (isHub || spoke) {
      // Add hub if on a spoke
      if (spoke && related.length < maxLinks) {
        related.push({
          path: cluster.hub,
          name: clusterName === "residential" ? "Residential Roofing" : 
                clusterName === "commercial" ? "Commercial Roofing" : "Roof Insurance Claims",
          anchor: getDeterministicAnchor(
            clusterName === "residential" ? ANCHOR_POOLS.residential :
            clusterName === "commercial" ? ANCHOR_POOLS.commercial : ANCHOR_POOLS.insurance,
            currentPath
          ),
        });
      }
      
      // Add 1-2 sibling spokes
      const siblings = cluster.spokes.filter(s => s.path !== currentPath);
      for (let i = 0; i < Math.min(2, siblings.length) && related.length < maxLinks; i++) {
        const sibling = siblings[i];
        related.push({
          path: sibling.path,
          name: sibling.name,
          anchor: getDeterministicAnchor(sibling.anchors, currentPath),
        });
      }
      
      break;
    }
  }
  
  return related.slice(0, maxLinks);
};
